import { BuilderSplitRow, BuilderSplitSnapshotRow } from "./types";

// detect deduction changes
export function getDeductionChanges(
  currentRows: BuilderSplitRow[],
  originalRows: BuilderSplitSnapshotRow[]
) {
  return currentRows.filter((row) => {
    const original = originalRows.find(
      (o) => o.employeeNumber === row.employeeNumber
    );

    if (!original) return false;

    const originalDeduction = original.deductionAmount || 0;
    const currentDeduction = row.deductionAmount || 0;

    return currentDeduction !== originalDeduction;
  });
}

// validate deduction comments
export function getRowsMissingDeductionComment(
  changedRows: BuilderSplitRow[]
) {
  return changedRows.filter(
    (row) =>
      (row.deductionAmount || 0) > 0 &&
      !(row.deductionComment && row.deductionComment.trim().length >= 3)
  );
}

// validate deduction does not exceed split amount
export function hasInvalidDeduction(rows: { deductionAmount?: number; splitAmount?: number }[]) {
    return rows.some(
        (row) => (row.deductionAmount || 0) > (row.splitAmount || 0)
    );
}